import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { PayrollData } from './PayrollTypes';

export const usePayrollProcessing = () => {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);

  const processPayroll = async (
    payrollData: PayrollData[], 
    startDate: string, 
    endDate: string
  ) => {
    try {
      setProcessing(true);
      
      // Save payroll calculations to database
      for (const employee of payrollData) {
        const { error: calcError } = await supabase
          .from('payroll_calculations')
          .insert({
            employee_id: employee.employee_id,
            period_start: startDate,
            period_end: endDate,
            total_hours: employee.total_hours,
            regular_hours: employee.regular_hours,
            overtime_hours: employee.overtime_hours,
            gross_pay: employee.gross_pay,
            deductions: employee.gross_pay - employee.net_pay,
            net_pay: employee.net_pay,
            status: 'calculated'
          });

        if (calcError) throw calcError;
      }

      toast.success('Payroll calculated and saved successfully');
      navigate('/employee-time-calendar');
    } catch (error) {
      console.error('Error processing payroll:', error);
      toast.error('Failed to process payroll');
    } finally {
      setProcessing(false);
    }
  };

  return {
    processing,
    processPayroll
  };
};